// Unpublished Work © 2020-2024 Deere & Company.

import * as actions from '../../action-list';
import {DomainData} from '../../state/struct/add-customer/domain-data';

const setDomainData = (state, action) =>
    DomainData.update(state, {
        $merge: action.domainData
    });

const setAllTaxIds = (state, action) => DomainData.update(state, {
    allTaxIds: {
        $set: action.allTaxIds
    }
});

const setPrivacyPolicies = (state, action) => DomainData.update(state, {
    allPrivacyPolicies: {
        $set: action.allPrivacyPolicies
    }
});

const setPreferredLanguageList = (state, action) => DomainData.update(state, {
    preferredLanguageList: {
        $set: action.preferredLanguageList
    }
});

const setStateOfSpecificCountryList = (state, action) => DomainData.update(state, {
    countryStatesList: {
        $set: action.countryStatesList
    }
});

export const domainData = (state = new DomainData({}), action = {}) => {
    const actionHandlers = {
        [actions.SET_ADD_CUSTOMER_DOMAIN_DATA]: setDomainData,
        [actions.SET_ALL_GOVERNMENT_TAX_IDS]: setAllTaxIds,
        [actions.SET_ALL_PRIVACY_POLICIES]: setPrivacyPolicies,
        [actions.SET_EDIT_CUSTOMER]: setDomainData,
        [actions.SET_PREFERRED_LANGUAGE_LIST]: setPreferredLanguageList,
        [actions.SET_STATES_OF_SPECIFIC_COUNTRY]: setStateOfSpecificCountryList
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
